import { z } from "zod";
import { RequestStateTypeEnumSchema } from "../Enums/RequestStateTypeEnum";

export const RequestDtoSchema = z.object({
    id: z.string(),
    eventDate: z.string(),
    createdDate: z.string(),
    answer: z.string().nullable(),
    userId: z.string(),
    isSubmitted: z.boolean(),
    requestStateId: RequestStateTypeEnumSchema,
    name: z.string().nullable(),
    icon: z.string().nullable(),
    iconColor: z.string().nullable(),
    description: z.string().nullable(),
    stateName: z.string().nullable(),
    stateIcon: z.string().nullable(),
    stateIconColor: z.string().nullable(),
    stateDescription: z.string().nullable(),
    identifier: z.string().nullable(),
    clientPartnerId: z.number().nullable(),
    clientName: z.string().nullable(),
    generatedDocumentId: z.string().nullable(),
    contractTitle: z.string().nullable(),
    contractSubtitle: z.string().nullable()
});

export type RequestDto = z.infer<typeof RequestDtoSchema>;